module.exports = __webpack_public_path__ + "static/homeBanner-da4521b492630e52419820e54c1107ff.jpg";